export const chartNoteText =
  "A decision aid called '{{toolname}}' [{{date}} version] was used to support a shared decision-making conversation by illustrating the benefits and harms of the available options.";
